import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useWallets } from "@/api/wallets"
import WalletUnlock from "./wallet-unlock"
import WithdrawalFlow from "./withdrawal.flow"
import { useState } from "react"

interface WithdrawalModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function WithdrawalModal({ open, onOpenChange }: WithdrawalModalProps) {
  const { wallet } = useWallets()
  const [isWithdrawing, setIsWithdrawing] = useState(false)

  if (!wallet) {
    return null
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => !isWithdrawing && onOpenChange(open)}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Withdraw</DialogTitle>
          {!isWithdrawing && <DialogClose />}
        </DialogHeader>
        <WalletUnlock>
          <WithdrawalFlow
            onDone={() => onOpenChange(false)}
            onStart={() => setIsWithdrawing(true)}
          />
        </WalletUnlock>
      </DialogContent>
    </Dialog>
  )
}
